namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_view_autoview, {

		Run: {
			width: '100%',
			height: '100%',
			minHeight: '100%',
			flex: {
				grow: 1,
			},
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
			padding: 0,
			border: {
				radius: 0,
			},
			background: {
				color: $mol_theme.shade,
			},
			color: $mol_theme.text,
			opacity: 0.3,
		},

		Run_icon: {
			width: '5rem',
			height: '5rem',
		},
		
	} )

}
